import { 
  Button, 
  Card,
  CardBody,
  Input,
  Typography } from "@material-tailwind/react";

import Subscribe from "../tekpon/subscribe-sidebar";

function tagToSlug(tag) {
  return tag.toLowerCase().replace(/\s/g, '-');
}

export default function RightSidenav({ recentPosts, topTags,  partner = "tekpon"}) {
  var root_path = "/software/news"
  if (partner == "tekpon") {
    root_path = "/software/news"
  } else if (partner = "waydev") {
    root_path = "/software-engineering-intelligence"
  }
  return (
    <>
    {
      partner == "tekpon" && (
        <Subscribe />
      )
    }
      <div className="sticky top-[80px] h-screen">
        
        <Card className="mt-6">
          <CardBody className="pb-2">
            <Typography variant="h6" color="blue-gray" className="mb-3 capitalize">
              Recommended Topics
            </Typography>
            {topTags && topTags.length > 0 && (
              topTags.map((tag, index) => (
                <div key={index} className="flex items-center justify-between mb-2">
                  <a href={`${root_path}/tag/${tagToSlug(tag.tag)}`}>
                    <Typography variant="paragraph" color="blue-gray" className="hover:font-normal">{tag.tag.replace(/-/g, ' ')}</Typography>
                  </a>
                  <Typography variant="small" color="blue-gray">{tag.count}</Typography>
                </div>
              ))
            )}

          </CardBody>
        </Card>
        <Card className="mt-6">
          <CardBody className="pb-2">
            <Typography variant="h6" color="blue-gray" className="mb-4 capitalize">
              Latest News
            </Typography>
            {recentPosts && recentPosts.length > 0 && (
              <ul>
                {recentPosts.slice(0, 3).map((post) => (
                  <li className="mb-4" key={post.slug.join("/")}>
                    <a href={`${root_path}/${post.slug.join("/")}`}>
                      <Typography variant="paragraph" color="blue-gray">{post.frontMatter.title}</Typography>
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </CardBody>
        </Card>

        <div className="bg-blue-500 w-full flex flex-col items-center justify-center py-6 shadow-lg hover:shadow-xl rounded-xl mt-6 transition-all" 
             style={{
                backgroundImage: 'url("https://raw.githubusercontent.com/creativetimofficial/public-assets/master/sei/header-sei.jpg")',
                backgroundSize: "cover",
                backgroundPosition: "center"
              }}
          >
          <a href="https://waydev.co/case-studies/?ref=creative-tim" target="_blank">
            
            <h3 className="text-white text-center text-lg">
              Start your journey with <br />Software Engineering Intelligence <br /> 
            </h3>
            <p className="uppercase text-xs text-white text-center font-bold mt-8">powered by</p>
            <img src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/sei/waydev-logo-white.png" alt="Logo" className="mb-2 mt-2 max-w-[100px] mx-auto" />
          </a>
         
        </div>

      </div>
    </>
  );
}
